import React from 'react';
import { Card, Button } from 'react-bootstrap';

const JavaScript = () => (
    <div className="card-grid">

        <Card className="card-box">
            <Card.Img  className="card-img" variant="top" src="/images/Techdegree-project-5-screenshot.png" />
            <Card.Body>
            <Card.Title>Photo Gallery</Card.Title>
            <Card.Text>
                        For this project the goal was to create an interactive photo gallery using 
                    some javascript and jQuery. By this point I have already learned some basic 
                    javascript and jQuery concepts and with the use of that I was able to successfully 
                    use some jQuery plugins to help me build the photo gallery section of the page. 
                    This also gave me a taste of open source code and how people share it with one 
                    another and implement them on their own websites.
            </Card.Text>
            <Button href="https://ramces14.github.io/Techdegree-project-5/" target="_blank">Enter</Button>
            </Card.Body>
        </Card>

        <Card className="card-box">
            <Card.Img  className="card-img" variant="top" src="/images/Techdegree-project-6-screenshot.png" />
            <Card.Body>
            <Card.Title>Wheel of Success</Card.Title>
            <Card.Text>
                        This project was my first attempt at manipulating the DOM. In this project I 
                    created a miniture version of the game show "wheel of fortune". I really enjoyed 
                    this project cause it was the first time I experince the power of javascript and the 
                    amount of interactivity that you add to a webpage to add to the user's experience.
            </Card.Text>
            <Button href="https://ramces14.github.io/Techdegree-project-6/" id="project-6-position" target="_blank">Enter</Button>
            </Card.Body>
        </Card>

        <Card className="card-box">
            <Card.Img  className="card-img" variant="top" src="/images/Techdegree-project-7-screenshot.png" />
            <Card.Body>
            <Card.Title>Responsive Dashboard</Card.Title>
            <Card.Text>
                        This is the first project where I had to put all my skills together to create a website 
                    that was not only aesthetically pleasing, but also interactive. For this project I was 
                    given a template to guide me through the design of the website.Everything from the HTML, 
                    CSS, and javascript was created by me except the charts. The charts were created with the 
                    help of Chart.js. This was a really fun project to work on because I was able to put everything 
                    together to show how far I’ve gone since the beginning of my journey.
            </Card.Text>
            <Button href="https://ramces14.github.io/Techdegree-project-7/" target="_blank">Enter</Button>
            </Card.Body>
        </Card>

        <Card className="card-box">
            <Card.Img  className="card-img" variant="top" src="/images/Techdegree-project-8-screenshot.png" />
            <Card.Body>
            <Card.Title>Employee Directory</Card.Title>
            <Card.Text>
                        The goal of this project was to create an Employee directory using an API that generated random 
                    users that have their own information like birthday, street address, and etc. This website was 
                    created with HTML, CSS and javascript, but most of the information was created using javascript 
                    to fetch most of the information using API’s. Like always this website is also responsive and has 
                    some interactivity as well.
            </Card.Text>
            <Button href="https://ramces14.github.io/Techdegree-project-8/" id="project-8-position" target="_blank">Enter</Button>
            </Card.Body>
        </Card>

    </div>
);

export default JavaScript;